import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const classes = {
  loadingContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 38px;
    margin: auto;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(classes);
